const API_BASE = import.meta.env.VITE_API_BASE_URL ?? "";

let activeAppContextId = "";
export function setActiveAppContextId(contextId: string | null | undefined) {
  activeAppContextId = contextId?.trim() ?? "";
}

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

function csrfToken() {
  const match = document.cookie.split("; ").find(x => x.startsWith("XSRF-TOKEN="));
  return match ? decodeURIComponent(match.split("=", 2)[1]) : undefined;
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = (init.method ?? "GET").toUpperCase();
  const headers = new Headers(init.headers);

  if (init.body && !headers.has("Content-Type") && !(init.body instanceof FormData)) headers.set("Content-Type", "application/json");
  if (activeAppContextId) headers.set("X-Yamar-App-Context", activeAppContextId);

  if (!["GET", "HEAD", "OPTIONS"].includes(method)) {
    const token = csrfToken();
    if (token) headers.set("X-CSRF-TOKEN", token);
  }

  const response = await fetch(`${API_BASE}${path}`, { ...init, headers, credentials: "include", cache: "no-store" });

  if (!response.ok) {
    if (response.status === 401 && !path.includes("/auth/login")) window.dispatchEvent(new CustomEvent("yamarhub:app-session-expired"));
    let message = response.status === 401 ? "Sua sessão expirou. Entre novamente." : "Não foi possível concluir a operação.";
    try {
      const body = await response.json();
      message = body.mensagem ?? body.title ?? message;
    } catch { /* resposta sem JSON */ }
    throw new ApiError(response.status, message);
  }

  if (response.status === 204) return undefined as T;
  return await response.json() as T;
}

export async function apiFetchBlob(path: string): Promise<Blob> {
  const headers = new Headers();
  if (activeAppContextId) headers.set("X-Yamar-App-Context", activeAppContextId);
  const response = await fetch(`${API_BASE}${path}`, { headers, credentials: "include", cache: "no-store" });
  if (!response.ok) {
    if (response.status === 401) window.dispatchEvent(new CustomEvent("yamarhub:app-session-expired"));
    throw new ApiError(response.status, "Não foi possível carregar a mídia protegida.");
  }
  return response.blob();
}
